import Chevron from '../../navigationMenu/components/chevron';
import Dropdown from '../../../../ui/dropdownMenu/dropdownMenu';
import { isSiteCanadian } from 'src/utils/helpers';
import { useTranslation } from 'react-i18next';
import {
    LABEL_TEXT_MENU_LANGUAGE,
    LABEL_TEXT_MENU_PROFILE_LANG_ENGLISH,
    LABEL_TEXT_MENU_PROFILE_LANG_FRENCH,
} from '../../../../../localization/resouceKeys';
import React, { useState } from 'react';
import '../assets/lang.scss';

export const Langlist: Array<{
    name: string;
    accron?: string;
    path?: string;
    handler?: any;
}> = [
    {
        name: LABEL_TEXT_MENU_LANGUAGE,
    },
    {
        name: LABEL_TEXT_MENU_PROFILE_LANG_ENGLISH,
        accron: 'EN',
        path: '#',
    },
    {
        name: LABEL_TEXT_MENU_PROFILE_LANG_FRENCH,
        accron: 'FR',
        path: '#',
    },
];

const MenuLang: React.FC = () => {
    const { i18n } = useTranslation();
    const [selected, setSelected] = useState<string>(
        LABEL_TEXT_MENU_PROFILE_LANG_ENGLISH,
    );
    const [open, setOpen] = useState<boolean>(false);
    const [setRotate, setRotateState] = useState<string>(
        'accordion__icon rotate',
    );
    function showSelected() {
        const index = Langlist.findIndex((e) => e && e.name === selected);
        return Langlist[index].accron;
    }
    function changeLanguage(lang: string) {
        setSelected(lang);
        i18n.changeLanguage(
            lang.includes('English')
                ? isSiteCanadian()
                    ? 'en-CA'
                    : 'en-US'
                : 'fr-CA',
        );
    }
    return (
        <div
            className={'language-list'}
            onClick={() => {
                setOpen(!open);
                setRotateState(
                    open
                        ? 'accordion__icon rotate'
                        : 'accordion__icon rotate-270',
                );
            }}
        >
            <i
                className={'c-icon-list__icon c-icon c-icon--[globe]'}
                aria-hidden='true'
                role='img'
            />
            {showSelected()}
            <span className={'u-mt-xlarge u-ml-xsmall'}>
                <Chevron className={`${setRotate}`} width={10} fill={'#777'} />
            </span>
            <Dropdown
                dropdown={open}
                submenus={Langlist}
                handlerChange={(value: boolean) => {
                    setOpen(value);
                    setRotateState(
                        !value
                            ? 'accordion__icon rotate'
                            : 'accordion__icon rotate-270',
                    );
                }}
                handlerItemChange={changeLanguage}
                showSelected={true}
                defaultSelected={selected}
                showSelectedIcon={true}
                right={'70'}
                shouldUseModal={false}
            />
        </div>
    );
};

export default MenuLang;
